var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"keyboard-area"},[_c('div',{ref:"keyboardWrapper",staticClass:"keyboard-wrapper"},[_c('div',{ref:"mover",staticClass:"keymap-info"},[(_vm.mapName)?_c('h3',{staticClass:"current-keymap"},[_vm._v("\n        "+_vm._s(_vm.mapName.toUpperCase().includes("LATYN")
            ? _vm.ls_KazakhLatyn
            : _vm.mapName.toUpperCase().includes("CYRL")
            ? _vm.ls_KazakhCyrl
            : _vm.ls_KazakhTote)+"\n      ")]):_vm._e(),_c('span',{staticClass:"close-btn",on:{"click":function($event){return _vm.$emit('closeKeyboard')}}},[_c('i',{staticClass:"fal fa-times"})])]),_c('ul',{staticClass:"keyboard"},_vm._l((_vm.keyMap),function(key,index){return _c('li',{key:index,staticClass:"key",class:{
          'delete-key': key === 'Delete',
          'tab-key': key === 'Tab',
          'caps-lock-key': key === 'Caps',
          'enter-key': key === 'Enter',
          'shift-key': key === 'Shift',
          'ctrl-key': key === 'Ctrl',
          'alt-key': key === 'Alt',
          'space-key': key === 'Space',
          'shift-ing': key === 'Shift' && _vm.shifted,
          'caps-lock-ing': key === 'Caps' && _vm.capsed,
          'ctrl-ing': key === 'Ctrl' && _vm.ctrled,
          'alt-ing': key === 'Alt' && _vm.alted,
          'font-kaznet': _vm.mapName === 'kazakhTote',
          'hovered-key':
            key === _vm.hoverKey ||
            (key === 'Space' && _vm.hoverKey === ' ') ||
            (key === 'Delete' && _vm.hoverKey === 8) ||
            (key === 'Caps' && _vm.hoverKey === 20) ||
            (key === 'Enter' && _vm.hoverKey === 13) ||
            (key === 'Shift' && _vm.hoverKey === 16) ||
            (key === 'Ctrl' && _vm.hoverKey === 17) ||
            (key === 'Alt' && _vm.hoverKey === 18)
        },on:{"click":function($event){return _vm.press(key)}}},[_vm._v("\n        "+_vm._s(key === "Space" ? "" : key)+"\n      ")])}),0)])])}
var staticRenderFns = []

export { render, staticRenderFns }